import { EntityType } from 'proto/generated/inspector_gadget';

export enum CLAIM_TYPE {
  COPYRIGHT = 'copyright',
  TRADEMARK = 'trademark',
  PUBLICITY_LIKENESS = 'publicity_likeness',
  OTHER = 'other',
}

export const CLAIM_TYPE_OPTIONS = Object.values(CLAIM_TYPE);

export enum CONTENT_TYPE {
  MUSIC = 'music',
  PODCAST = 'podcast',
  ARTWORK = 'artwork',
  USER_IMAGE = 'user_image',
  PLAYLIST_IMAGE = 'playlist_image',
  PLAYLIST_TITLE = 'playlist_title',
  PLAYLIST_DESCRIPTION = 'playlist_description',
  ARTIST_PROFILE_IMAGE = 'artist_profile_image',
  ARTIST_BANNER_IMAGE = 'artist_banner_image',
  ARTIST_GALLERY_IMAGE = 'artist_gallery_image',
  ARTIST_BIO_TEXT = 'artist_bio_text',
  ARTIST_PICK_TEXT = 'artist_pick_text',
  ARTIST_MERCHANDISE = 'artist_merchandise',
  NOW_PLAYING = 'now_playing',
  OTHER = 'other',
  AUDIOBOOK = 'audiobook',
  ARTIST_VIDEO_VIDEO = 'artist_video_video',
  ARTIST_VIDEO_TITLE = 'artist_video_title',
  ARTIST_VIDEO_AUDIO = 'artist_video_audio',
  QUESTION_TEXT = 'question_text',
  RESPONSE_TEXT = 'response_text',
  POLL_QUESTION_TEXT = 'poll_question_text',
  COMMENT_TEXT = 'comment_text',
  POLL_OPTIONS_TEXT = 'poll_options_text',
  MERCH_TITLE = 'merch_title',
  MERCH_DESCRIPTION = 'merch_description',
  MERCH_IMAGE_GALLERY = 'merch_image_gallery',
  MUSIC_VIDEO = 'music_video',
  CHAT_MESSAGE_TEXT = 'chat_message_text',
  PODCAST_THUMBNAIL_IMAGE = 'podcast_thumbnail_image',
  EPISODE_VIDEO_PREVIEW_AUDIO = 'episode_video_preview_audio',
  EPISODE_VIDEO_PREVIEW_VIDEO = 'episode_video_preview_video',
  EPISODE_VIDEO_PREVIEW_TITLE = 'episode_video_preview_title',
  SUPPLEMENTARY_PDF = 'supplementary_pdf',
}

export const ASSOCIATED_CONTENT_TYPES: Set<CONTENT_TYPE> = new Set([
  CONTENT_TYPE.ARTIST_BANNER_IMAGE,
  CONTENT_TYPE.ARTIST_GALLERY_IMAGE,
  CONTENT_TYPE.ARTIST_PROFILE_IMAGE,
  CONTENT_TYPE.ARTWORK,
  CONTENT_TYPE.PODCAST_THUMBNAIL_IMAGE,
]);

export const ENTITY_TYPES_WITH_ASSOCIATED_CONTENT: Set<EntityType> = new Set([
  EntityType.ENTITY_TYPE_ARTIST,
  EntityType.ENTITY_TYPE_EPISODE,
]);
